var map = {
	"./": 83271,
	"./dev": 31992,
	"./dev.js": 31992,
	"./index": 83271,
	"./index.js": 83271,
	"./prod": 97586,
	"./prod.js": 97586,
	"./staging": 47606,
	"./staging.js": 47606,
	"./test": 39887,
	"./test.js": 39887,
	"./uat": 52977,
	"./uat.js": 52977
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49607;